const styles = {
  root: {
    cursor: 'pointer',
    outline: 0,
    border: 2,
    borderColor: 'text.black',
    borderRadius: 2,
    '&:hover': {
      backgroundColor: 'background.white',
    },
  },

  button: {
    backgroundColor: 'background.white',
    color: '#000',
    textTransform: 'uppercase',
    '&.MuiButton-root.slim': {
      padding: '4px 16px!important',
    },
  },

  chip: {
    position: 'relative',
    marginLeft: 1,
    backgroundColor: 'primary.main',
    color: '#fff !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '20px',
    borderRadius: '50%',
    height: '20px',
    '&.MuiChip-label': {
      border: '2px solid red',
    },
    '& .MuiTypography-root.MuiTypography-quote': {
      color: 'text.white',
    },
  },
}

export default styles
